import React from "react";
import Zoom from "react-reveal/LightSpeed";
import { NavLink } from "react-router-dom";

const Service = () => {
    const services = [
        {
            number: "01",
            icon: "📊",
            title: "Finance & Accounting Outsourcing",
            shortTitle: "Finance & Accounting",
            description:
                "Outsource your accounting and finance operations to skilled professionals and focus your internal team on higher-value business priorities.",
            points: [
                "Accounting & Bookkeeping",
                "Accounts Payable & Receivable",
                "R2R & General Ledger",
                "Bank & Balance Sheet Reconciliation",
                "MIS & Financial Reporting",
                "FP&A Support",
                "Virtual Accountants",
                "Complete Finance Operations"
            ]
        },
        {
            number: "02",
            icon: "👥",
            title: "Staffing & Third-Party Payroll",
            shortTitle: "Staffing & Payroll",
            description:
                "Get qualified professionals through flexible staffing and third-party payroll models while Himsal manages the employment administration.",
            points: [
                "Finance & Accounting Professionals",
                "IT Professionals",
                "Contract Staffing",
                "Third-Party Payroll",
                "Employee Onboarding",
                "Payroll Administration",
                "Employee Records & Support",
                "Dedicated Professionals"
            ]
        },
        {
            number: "03",
            icon: "💻",
            title: "IT Staffing & Technology",
            shortTitle: "IT & Technology",
            description:
                "Strengthen your technology team with skilled professionals and practical software development services aligned with your business requirements.",
            points: [
                "IT Staff Augmentation",
                "Dedicated Developers",
                "Backend Development",
                "Frontend Development",
                "Full-Stack Development",
                "API Development",
                "Web Applications",
                "Technical Support"
            ]
        },
        {
            number: "04",
            icon: "🌐",
            title: "Website & Software Development",
            shortTitle: "Web & Software",
            description:
                "We design and develop professional websites and web-based software solutions that help businesses establish, improve and scale their digital presence.",
            points: [
                "Corporate Websites",
                "Business Websites",
                "E-commerce Websites",
                "Custom Web Applications",
                "Business Portals",
                "API & Backend Solutions",
                "Website Maintenance",
                "Technology Support"
            ]
        },
        {
            number: "05",
            icon: "⚙️",
            title: "Business Process Outsourcing",
            shortTitle: "BPO & Managed Services",
            description:
                "Outsource specific business processes or complete operational functions to dedicated Himsal professionals and teams.",
            points: [
                "Finance Operations",
                "Accounting Operations",
                "Back-office Support",
                "Payroll Operations",
                "Data & Process Support",
                "Dedicated Operations Teams",
                "Managed Business Processes",
                "Process Outsourcing"
            ]
        }
    ];

    const engagementModels = [
        {
            icon: "👤",
            title: "Dedicated Professional",
            description:
                "Need one accountant, finance professional or IT specialist? We provide a professional based on your specific requirement."
        },
        {
            icon: "👥",
            title: "Dedicated Team",
            description:
                "Build a complete team for finance, accounting, technology or business operations without handling every hiring requirement yourself."
        },
        {
            icon: "🔄",
            title: "Managed Services",
            description:
                "Outsource an entire process or function and let Himsal manage the required people and day-to-day operations."
        },
        {
            icon: "🚀",
            title: "Project Based",
            description:
                "Have a specific website, web application or software requirement? We can build a solution around your project."
        }
    ];

    const industries = [
        { name: "Startups & SMEs", icon: "🚀" },
        { name: "Technology", icon: "💻" },
        { name: "Healthcare", icon: "🏥" },
        { name: "Education", icon: "🎓" },
        { name: "E-commerce", icon: "🛒" },
        { name: "Manufacturing", icon: "🏭" },
        { name: "Professional Services", icon: "💼" },
        { name: "Financial Services", icon: "🏦" }
    ];

    return (
        <div
            className="himsal-service-page"
            style={{
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                backgroundColor: "#f8fafc",
                color: "#0f172a",
                width: "100%",
                overflowX: "hidden"
            }}
        >

            {/* =====================================================
                HERO
            ===================================================== */}
            <section
                className="himsal-service-hero"
                style={{
                    background:
                        "linear-gradient(135deg, #07162c 0%, #0b1f3a 55%, #12345b 100%)",
                    color: "#ffffff",
                    textAlign: "center",
                    position: "relative",
                    overflow: "hidden",
                    boxSizing: "border-box"
                }}
            >
                <div className="himsal-hero-circle-one" />
                <div className="himsal-hero-circle-two" />

                <div
                    className="container"
                    style={{
                        position: "relative",
                        zIndex: 2
                    }}
                >
                    <Zoom>
                        <div
                            style={{
                                display: "inline-block",
                                padding: "8px 16px",
                                borderRadius: "50px",
                                backgroundColor:
                                    "rgba(59,130,246,0.14)",
                                border:
                                    "1px solid rgba(96,165,250,0.25)",
                                color: "#93c5fd",
                                fontSize: "12px",
                                fontWeight: "800",
                                letterSpacing: "1.5px",
                                marginBottom: "22px"
                            }}
                        >
                            OUR SERVICES
                        </div>

                        <h1
                            style={{
                                fontSize: "clamp(2.2rem, 6vw, 4rem)",
                                fontWeight: "800",
                                letterSpacing: "-1px",
                                lineHeight: "1.1",
                                margin: "0 auto 20px",
                                maxWidth: "850px",
                                color: "#ffffff"
                            }}
                        >
                            Solutions That Help
                            <br />
                            <span style={{ color: "#60a5fa" }}>
                                Your Business Scale
                            </span>
                        </h1>

                        <p
                            style={{
                                color: "#cbd5e1",
                                maxWidth: "720px",
                                margin: "0 auto",
                                fontSize: "17px",
                                lineHeight: "1.8"
                            }}
                        >
                            From Finance & Accounting Outsourcing and
                            professional staffing to third-party payroll,
                            IT services and web development, Himsal provides
                            flexible solutions built around your business
                            needs.
                        </p>
                    </Zoom>
                </div>
            </section>

            {/* =====================================================
                INTRO
            ===================================================== */}
            <section
                style={{
                    padding: "80px 20px 45px",
                    backgroundColor: "#ffffff"
                }}
            >
                <div
                    className="container"
                    style={{
                        maxWidth: "850px",
                        textAlign: "center",
                        margin: "0 auto"
                    }}
                >
                    <div
                        style={{
                            color: "#2563eb",
                            fontSize: "13px",
                            fontWeight: "800",
                            letterSpacing: "1.5px",
                            textTransform: "uppercase",
                            marginBottom: "12px"
                        }}
                    >
                        What We Offer
                    </div>

                    <h2
                        style={{
                            color: "#0f172a",
                            fontSize: "clamp(2rem, 4vw, 2.8rem)",
                            fontWeight: "800",
                            margin: "0 0 18px",
                            lineHeight: "1.2"
                        }}
                    >
                        One Partner for
                        <br />
                        <span style={{ color: "#2563eb" }}>
                            Multiple Business Needs
                        </span>
                    </h2>

                    <p
                        style={{
                            color: "#64748b",
                            fontSize: "16px",
                            lineHeight: "1.8",
                            margin: 0
                        }}
                    >
                        Whether you need an individual professional, a
                        dedicated team, outsourced business operations or a
                        technology solution, we provide flexible engagement
                        models that can grow with your business.
                    </p>
                </div>
            </section>

            {/* =====================================================
                SERVICES
            ===================================================== */}
            <section
                style={{
                    padding: "40px 20px 90px",
                    backgroundColor: "#ffffff"
                }}
            >
                <div
                    className="container"
                    style={{
                        maxWidth: "1150px",
                        margin: "0 auto"
                    }}
                >
                    {services.map((service, index) => (
                        <div
                            key={service.number}
                            className={`himsal-service-row ${
                                index % 2 !== 0
                                    ? "himsal-service-row-reverse"
                                    : ""
                            }`}
                        >
                            {/* SERVICE CONTENT */}
                            <div className="himsal-service-content">

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "16px",
                                        marginBottom: "20px"
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "56px",
                                            height: "56px",
                                            minWidth: "56px",
                                            borderRadius: "12px",
                                            backgroundColor: "#eff6ff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "27px"
                                        }}
                                    >
                                        {service.icon}
                                    </div>

                                    <span
                                        style={{
                                            color: "#cbd5e1",
                                            fontSize: "13px",
                                            fontWeight: "800",
                                            letterSpacing: "1px"
                                        }}
                                    >
                                        SERVICE {service.number}
                                    </span>
                                </div>

                                <h2
                                    style={{
                                        color: "#0f172a",
                                        fontSize:
                                            "clamp(1.8rem, 3vw, 2.5rem)",
                                        fontWeight: "800",
                                        lineHeight: "1.2",
                                        margin: "0 0 18px"
                                    }}
                                >
                                    {service.title}
                                </h2>

                                <p
                                    style={{
                                        color: "#64748b",
                                        fontSize: "15px",
                                        lineHeight: "1.85",
                                        margin: "0 0 25px"
                                    }}
                                >
                                    {service.description}
                                </p>

                                <NavLink
                                    to="/contact"
                                    style={{
                                        display: "inline-block",
                                        color: "#2563eb",
                                        fontSize: "14px",
                                        fontWeight: "800",
                                        textDecoration: "none"
                                    }}
                                >
                                    Discuss Your Requirement →
                                </NavLink>
                            </div>

                            {/* SERVICE POINTS */}
                            <div
                                className="himsal-service-points"
                                style={{
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "14px",
                                    padding: "30px",
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    style={{
                                        color: "#0f172a",
                                        fontSize: "16px",
                                        fontWeight: "800",
                                        marginBottom: "20px"
                                    }}
                                >
                                    What We Can Help With
                                </div>

                                <div className="himsal-points-grid">
                                    {service.points.map((point) => (
                                        <div
                                            key={point}
                                            style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "9px",
                                                color: "#475569",
                                                fontSize: "13px",
                                                lineHeight: "1.5"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#2563eb",
                                                    fontWeight: "800",
                                                    flexShrink: 0
                                                }}
                                            >
                                                ✓
                                            </span>

                                            <span>{point}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* =====================================================
                ENGAGEMENT MODELS
            ===================================================== */}
            <section
                style={{
                    padding: "85px 20px",
                    backgroundColor: "#f8fafc"
                }}
            >
                <div
                    className="container"
                    style={{
                        maxWidth: "1150px",
                        margin: "0 auto"
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            maxWidth: "750px",
                            margin: "0 auto 50px"
                        }}
                    >
                        <div
                            style={{
                                color: "#2563eb",
                                fontSize: "13px",
                                fontWeight: "800",
                                letterSpacing: "1.5px",
                                textTransform: "uppercase",
                                marginBottom: "12px"
                            }}
                        >
                            Engagement Models
                        </div>

                        <h2
                            style={{
                                color: "#0f172a",
                                fontSize:
                                    "clamp(2rem, 4vw, 2.8rem)",
                                fontWeight: "800",
                                margin: "0 0 18px",
                                lineHeight: "1.2"
                            }}
                        >
                            Choose How You Want to Work With Us
                        </h2>

                        <p
                            style={{
                                color: "#64748b",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                margin: 0
                            }}
                        >
                            Start small or build a complete operation. Our
                            engagement models are designed to adapt to your
                            business.
                        </p>
                    </div>

                    <div className="himsal-engagement-grid">
                        {engagementModels.map((model, index) => (
                            <div
                                key={model.title}
                                style={{
                                    backgroundColor: "#ffffff",
                                    padding: "30px",
                                    borderRadius: "12px",
                                    border: "1px solid #e2e8f0",
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "10px",
                                        backgroundColor:
                                            index === 0
                                                ? "#dbeafe"
                                                : "#f1f5f9",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "23px",
                                        marginBottom: "20px"
                                    }}
                                >
                                    {model.icon}
                                </div>

                                <h3
                                    style={{
                                        color: "#0f172a",
                                        fontSize: "18px",
                                        fontWeight: "800",
                                        margin: "0 0 10px"
                                    }}
                                >
                                    {model.title}
                                </h3>

                                <p
                                    style={{
                                        color: "#64748b",
                                        fontSize: "14px",
                                        lineHeight: "1.75",
                                        margin: 0
                                    }}
                                >
                                    {model.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =====================================================
                INDUSTRIES
            ===================================================== */}
            <section
                style={{
                    padding: "85px 20px",
                    backgroundColor: "#07162c",
                    color: "#ffffff"
                }}
            >
                <div
                    className="container"
                    style={{
                        maxWidth: "1150px",
                        margin: "0 auto",
                        textAlign: "center"
                    }}
                >
                    <div
                        style={{
                            color: "#60a5fa",
                            fontSize: "13px",
                            fontWeight: "800",
                            letterSpacing: "1.5px",
                            textTransform: "uppercase",
                            marginBottom: "12px"
                        }}
                    >
                        Industries We Serve
                    </div>

                    <h2
                        style={{
                            color: "#ffffff",
                            fontSize:
                                "clamp(2rem, 4vw, 2.8rem)",
                            fontWeight: "800",
                            margin: "0 0 18px"
                        }}
                    >
                        Supporting Growing Businesses
                    </h2>

                    <p
                        style={{
                            color: "#94a3b8",
                            maxWidth: "700px",
                            margin: "0 auto 45px",
                            fontSize: "15px",
                            lineHeight: "1.8"
                        }}
                    >
                        Our services can be adapted to the operational,
                        staffing and technology requirements of businesses
                        across different industries.
                    </p>

                    <div className="himsal-industry-grid">
                        {industries.map((industry) => (
                            <div
                                key={industry.name}
                                style={{
                                    backgroundColor:
                                        "rgba(255,255,255,0.05)",
                                    border:
                                        "1px solid rgba(255,255,255,0.10)",
                                    borderRadius: "10px",
                                    padding: "25px 15px",
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "28px",
                                        marginBottom: "12px"
                                    }}
                                >
                                    {industry.icon}
                                </div>

                                <div
                                    style={{
                                        color: "#ffffff",
                                        fontSize: "14px",
                                        fontWeight: "700"
                                    }}
                                >
                                    {industry.name}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =====================================================
                FINAL CTA
            ===================================================== */}
            <section
                style={{
                    padding: "75px 20px",
                    backgroundColor: "#ffffff"
                }}
            >
                <div
                    className="himsal-service-cta"
                >
                    <div
                        style={{
                            color: "#93c5fd",
                            fontSize: "12px",
                            fontWeight: "800",
                            letterSpacing: "1.5px",
                            marginBottom: "15px"
                        }}
                    >
                        HAVE A REQUIREMENT?
                    </div>

                    <h2
                        style={{
                            color: "#ffffff",
                            fontSize:
                                "clamp(2rem, 4vw, 3rem)",
                            fontWeight: "800",
                            margin: "0 0 18px",
                            lineHeight: "1.2"
                        }}
                    >
                        Let's Build the Right Solution
                    </h2>

                    <p
                        style={{
                            color: "#cbd5e1",
                            maxWidth: "650px",
                            margin: "0 auto",
                            fontSize: "15px",
                            lineHeight: "1.8"
                        }}
                    >
                        Tell us about your staffing, finance, payroll,
                        outsourcing or technology requirement. Our team will
                        help you explore the right engagement model.
                    </p>

                    <NavLink
                        to="/contact"
                        style={{
                            display: "inline-block",
                            marginTop: "30px",
                            backgroundColor: "#ffffff",
                            color: "#0b1f3a",
                            padding: "15px 30px",
                            borderRadius: "8px",
                            fontWeight: "800",
                            textDecoration: "none"
                        }}
                    >
                        Talk to Himsal →
                    </NavLink>
                </div>
            </section>

            {/* =====================================================
                RESPONSIVE CSS
            ===================================================== */}
            <style>
                {`
                    .himsal-service-hero {
                        padding: 95px 20px;
                    }

                    .himsal-hero-circle-one {
                        position: absolute;
                        width: 400px;
                        height: 400px;
                        border-radius: 50%;
                        background-color: rgba(59,130,246,0.08);
                        top: -200px;
                        right: -100px;
                        pointer-events: none;
                    }

                    .himsal-hero-circle-two {
                        position: absolute;
                        width: 300px;
                        height: 300px;
                        border-radius: 50%;
                        background-color: rgba(14,165,233,0.06);
                        bottom: -160px;
                        left: -100px;
                        pointer-events: none;
                    }

                    .himsal-service-row {
                        display: grid;
                        grid-template-columns:
                            minmax(280px, 0.85fr)
                            minmax(300px, 1.15fr);
                        gap: 55px;
                        align-items: center;
                        padding: 55px 0;
                        border-bottom: 1px solid #e2e8f0;
                    }

                    .himsal-service-row:last-child {
                        border-bottom: none;
                    }

                    .himsal-service-row-reverse
                        .himsal-service-content {
                        order: 2;
                    }

                    .himsal-service-row-reverse
                        .himsal-service-points {
                        order: 1;
                    }

                    .himsal-points-grid {
                        display: grid;
                        grid-template-columns:
                            repeat(2, minmax(0, 1fr));
                        gap: 13px;
                    }

                    .himsal-engagement-grid {
                        display: grid;
                        grid-template-columns:
                            repeat(4, minmax(0, 1fr));
                        gap: 20px;
                    }

                    .himsal-industry-grid {
                        display: grid;
                        grid-template-columns:
                            repeat(4, minmax(0, 1fr));
                        gap: 15px;
                    }

                    .himsal-service-cta {
                        max-width: 1050px;
                        margin: 0 auto;
                        border-radius: 18px;
                        padding: 65px 30px;
                        background:
                            linear-gradient(
                                135deg,
                                #0b1f3a 0%,
                                #123b68 100%
                            );
                        text-align: center;
                        box-sizing: border-box;
                    }

                    /* ============================================
                       TABLET
                    ============================================ */

                    @media (max-width: 1000px) {
                        .himsal-service-row {
                            grid-template-columns:
                                minmax(260px, 1fr)
                                minmax(280px, 1fr);
                            gap: 35px;
                        }

                        .himsal-engagement-grid {
                            grid-template-columns:
                                repeat(2, minmax(0, 1fr));
                        }

                        .himsal-industry-grid {
                            grid-template-columns:
                                repeat(4, minmax(0, 1fr));
                        }
                    }

                    /* ============================================
                       MOBILE
                    ============================================ */

                    @media (max-width: 700px) {
                        .himsal-service-hero {
                            padding: 75px 18px;
                        }

                        .himsal-service-row {
                            display: flex;
                            flex-direction: column;
                            gap: 25px;
                            padding: 40px 0;
                            align-items: stretch;
                        }

                        .himsal-service-row-reverse
                            .himsal-service-content {
                            order: 1;
                        }

                        .himsal-service-row-reverse
                            .himsal-service-points {
                            order: 2;
                        }

                        .himsal-service-content {
                            width: 100%;
                        }

                        .himsal-service-points {
                            width: 100%;
                            padding: 24px !important;
                        }

                        .himsal-points-grid {
                            grid-template-columns: 1fr;
                            gap: 12px;
                        }

                        .himsal-engagement-grid {
                            grid-template-columns: 1fr;
                            gap: 15px;
                        }

                        .himsal-industry-grid {
                            grid-template-columns:
                                repeat(2, minmax(0, 1fr));
                            gap: 12px;
                        }

                        .himsal-service-cta {
                            padding: 45px 22px;
                            border-radius: 14px;
                        }
                    }

                    /* ============================================
                       SMALL MOBILE
                    ============================================ */

                    @media (max-width: 380px) {
                        .himsal-service-hero {
                            padding: 65px 15px;
                        }

                        .himsal-service-row {
                            padding: 35px 0;
                        }

                        .himsal-service-points {
                            padding: 20px !important;
                        }

                        .himsal-industry-grid {
                            grid-template-columns: 1fr;
                        }

                        .himsal-service-cta {
                            padding: 40px 18px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Service;
